var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wo-breadcrumb',{attrs:{"label":"Breadcrumb","mod-boxed":""}},_vm._l((_vm.validRoutes),function(route,index){return _c('wo-breadcrumb-item',{key:index},[_c('po-route-link',{attrs:{"value":route}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }